<template>
  <div class="modal right fade bd-example-modal-lg" id="modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document" :class="modal.width === true ? 'quickViewModalDialog' : ''">
      <div class="modal-content">
        <!-- modal header -->
        <div class="modal-header">
          <h4 class="modal-title">{{ modal.title }}</h4>
            <button type="button" class="close cross" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              <font-awesome-icon icon="times" />
            </span>
          </button>
        </div>
        <hr class="mb-0 mt-1" />
        <!-- modal body -->
        <div class="modal-body hide-scroll">
          <!-- <hr class="bg-muted mt-n1"> -->
          <component v-if="modal.show" :is="modal.component" :action="modal.action" :formData="modal.formData"
            :key="modal.__key || modal.title"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      modal: function () {
        return this.$store.getters["modal/structure"];
      },
    },
  };
</script>
<style>
@media (min-width: 576px) {
  .quickViewModalDialog{
    max-width: calc(100vw - 270px);
  }
}
</style>